import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId,
    search = '',
    filters = [],
    sort = [],
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.projectItem.getPage, {
        projId,
        search,
        filters,
        sort,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pi, ps };
};

